export { default as General } from 'catalogs/components/form/sections/CatalogFormGeneral';
export { default as Elements } from 'catalogs/components/form/sections/CatalogFormElements';



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/form/sections/index.js